import ScheduleTime from './scheduleTime'

const defaultScheduleTimes = {
  standardHours: {
    startTime: '09:00',
    endTime: '17:00',
  },
  standardBreak: {
    startTime: '12:30',
    endTime: '13:00',
  },
}
/**
 * Represents all time blocks for a single day in a schedule
 * @param {ScheduleTime} standardHours - Array of ScheduleTime objects for the standard working hours for a day
 * @param {ScheduleTime} standardBreak - Array of ScheduleTime objects for the standard break times for a day
 */
export default class ScheduleTimes {
  constructor({ standardHours, standardBreak } = defaultScheduleTimes) {
    this.standardHours = new ScheduleTime(standardHours)
    this.standardBreak = new ScheduleTime(standardBreak)
  }
}
